import React, { useState } from 'react';
import styles from './GeneralModalMaker.module.scss';
import { Modal, Group, Title, Alert, LoadingOverlay } from '@mantine/core';

type Props = {
  children: React.ReactNode,
}

function GeneralModalMaker({children}:Props) {
  return (
    <Modal
      className={styles.GeneralModalMaker}
      opened={true}
      withCloseButton={false}
      onClose={() => {/** outside click */}}
      centered
      overflow="inside"
      size={640}
    >
      {children}
    </Modal>
  );
}

export default GeneralModalMaker;